module.exports = "<p>\n  role-view works!\n</p>\n"